import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".SelectInput-module_select__md9bU {\n  min-width: var(--size-1000);\n}";
var selectStyles = {"select":"SelectInput-module_select__md9bU"};
styleInject(css_248z);

export { selectStyles as default };
